import { ProjectId } from 'modules/domains/project';
import { UserId } from 'modules/domains/user';
import { GraphQLTypeNameData, GRAPHQL_TYPENAMES, OffsetDateTime } from 'modules/graphql/types';

export type ListId = number;
export type ListPublicId = number;
export enum ListType {
  Standard = 'Standard',
  Dynamic = 'Dynamic',
  Suppression = 'Suppression',
  Internal = 'Internal',
}

// Partial list types
export type ListIdData = { id: ListId };
export type ListNameData = { name: string };
export type ListProjectIdData = { projectId: ProjectId };
export type ListTypeData = { listType: ListType };
export type ListPublicIdData = { publicId: ListPublicId };
export type ListCreatorData = { creatorUserId: UserId };
export type ListSizeData = { size: number | null };
export type ListCreatedAtData = { createdAt: OffsetDateTime };
export type ListUpdatedAtData = { updatedAt: OffsetDateTime };
export type ListDescriptionData = { description: string | null };
export type ListHasBrandAffinityQuery = { hasBrandAffinityQuery: boolean };
export type ListUpdatedByUserId = { updatedByUserId: string };
export type ListTypeNameData = GraphQLTypeNameData<GRAPHQL_TYPENAMES.LIST>;

// Full type (NOTE: please add new list partial types to this union)
export type List = ListIdData &
  ListNameData &
  ListProjectIdData &
  ListTypeData &
  ListPublicIdData &
  ListCreatorData &
  ListSizeData &
  ListCreatedAtData &
  ListUpdatedAtData &
  ListDescriptionData &
  ListHasBrandAffinityQuery &
  ListUpdatedByUserId &
  ListTypeNameData;

// List GraphQL query (variables + response)
export type ListGraphQLQueryVariables = { id: ListId };
export type ListGraphQLQueryResponse<ListData extends Partial<List>> = {
  list: ListData | null;
};
